import { render, staticRenderFns } from "./EditDispatchTypeReasonModal.vue?vue&type=template&id=4c05aa36&"
import script from "./EditDispatchTypeReasonModal.vue?vue&type=script&lang=js&"
export * from "./EditDispatchTypeReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports